// Mock data para a página de accueil - sem conexões de API
export const mockAccueilData = {
  projects: [
    {
      project_id: 119,
      project_name: 'Projet CO05a',
      favorite: true,
    },
    {
      project_id: 1119,
      project_name: 'Projet Galerie Intertube',
      favorite: true,
    },
    {
      project_id: 2,
      project_name: 'Projet Demo',
      favorite: false,
    },
    {
      project_id: 3,
      project_name: 'Projet Estacao Ferroviaria',
      favorite: true,
    },
    {
      project_id: 4,
      project_name: 'Projet Usina Hidroeletrica',
      favorite: true,
    },
    {
      project_id: 5,
      project_name: 'Projet Porto Maritimo',
      favorite: true,
    },
    {
      project_id: 6,
      project_name: 'Projet Aeroporto Terminal Sul',
      favorite: false,
    },
    {
      project_id: 7,
      project_name: 'Projet Fabrica de Texteis',
      favorite: false,
    },
  ],

  views: [
    {
      view_id: 2330,
      view_name: 'Plan site de sécurité CO05a',
      view_title: 'Localisation des capteurs',
      project_id: 119,
      view_projection: 0,
      view_copyright: 'ITM+',
      view_flag_fix_pos: 1,
      view_type: 0,
      is_main_view: 1,
      is_visible: 1,
      is_clustered: 1,
      update_time: null,
      view_bound_coordinates: [
        [0, 0],
        [5398, 11810],
      ],
      view_zoom_levels: [-3, 5],
      center: [48.8566, 2.3522],
      zoom: 12,
    },
    {
      view_id: 2358,
      view_name: 'Plan Galerie Intertube',
      view_title: 'Galerie Intertube',
      project_id: 1119,
      view_projection: 0,
      view_copyright: 'ITM+',
      view_flag_fix_pos: 1,
      view_type: 0,
      is_main_view: 1,
      is_visible: 1,
      is_clustered: 1,
      update_time: null,
      view_bound_coordinates: [
        [0, 0],
        [4678, 6617],
      ],
      view_zoom_levels: [-3, 5],
      center: [48.9, 2.4],
      zoom: 13,
    },
  ],

  graphs: [
    {
      graph_id: 301,
      graph_name: 'Graphe Température CO05a',
      project_id: 119,
      graph_type: 'line',
      created_date: new Date().toISOString(),
    },
    {
      graph_id: 302,
      graph_name: 'Graphe Humidité',
      project_id: 119,
      graph_type: 'bar',
      created_date: new Date().toISOString(),
    },
  ],

  alarms: [
    {
      alarm_id: 1,
      label: 'Température trop élevée CO05a',
      severity: 'critical',
      date: Math.floor(Date.now() / 1000),
      project_id: 119,
      sensor_id: 'TEMP_01',
    },
    {
      alarm_id: 2,
      label: 'Capteur non réactif',
      severity: 'warning',
      date: Math.floor(Date.now() / 1000) - 3600,
      project_id: 119,
      sensor_id: 'HUM_02',
    },
    {
      alarm_id: 3,
      label: 'Batterie faible',
      severity: 'info',
      date: Math.floor(Date.now() / 1000) - 7200,
      project_id: 1119,
      sensor_id: 'BATT_01',
    },
  ],

  reports: [
    {
      rapport_id: 1,
      titre: 'Rapport mensuel CO05a - Février 2026',
      description: 'Analyse complète des données',
      date: Math.floor(Date.now() / 1000),
      project_id: 119,
      status: 'generated',
    },
    {
      rapport_id: 2,
      titre: "Rapport d'incidents",
      description: 'Incidents du mois',
      date: Math.floor(Date.now() / 1000) - 86400,
      project_id: 119,
      status: 'generated',
    },
    {
      rapport_id: 3,
      titre: 'Rapport Galerie Intertube',
      description: 'Données de janvier',
      date: Math.floor(Date.now() / 1000) - 172800,
      project_id: 1119,
      status: 'generated',
    },
  ],

  dashboards: [
    {
      dashboard_id: 201,
      dashboard_name: 'Tableau de bord CO05a',
      project_id: 119,
      created_date: new Date().toISOString(),
      image_url:
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23e8f4f8" width="400" height="300"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%234c4c4c" font-size="24" font-weight="bold"%3ETableau CO05a%3C/text%3E%3C/svg%3E',
    },
    {
      dashboard_id: 202,
      dashboard_name: 'Tableau de bord Galerie',
      project_id: 1119,
      created_date: new Date().toISOString(),
      image_url:
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23f0e68c" width="400" height="300"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23333" font-size="24" font-weight="bold"%3ETableau Galerie%3C/text%3E%3C/svg%3E',
    },
  ],

  summary: {
    alarmes: [
      {
        alarm_id: 1,
        message_alarm: 'Temperatura demasiado elevada CO05a',
        alarm_level: 1,
        alarm_time_firing: Math.floor(Date.now() / 1000),
        project_id: 119,
      },
      {
        alarm_id: 2,
        message_alarm: 'Humidade baixa Galeria Intertube',
        alarm_level: 2,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 3600,
        project_id: 1119,
      },
      {
        alarm_id: 3,
        message_alarm: 'Pressão anormal detectada',
        alarm_level: 1,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 7200,
        project_id: 119,
      },
      {
        alarm_id: 4,
        message_alarm: 'Sensor desconectado CO05a',
        alarm_level: 2,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 10800,
        project_id: 119,
      },
      {
        alarm_id: 5,
        message_alarm: 'Falha de comunicacao',
        alarm_level: 3,
        alarm_time_firing: Math.floor(Date.now() / 1000) - 14400,
        project_id: 1119,
      },
    ],
    rapports: [
      {
        rapport_id: 1,
        titre: 'Rapport mensuel CO05a',
        date: Math.floor(Date.now() / 1000),
        project_id: 119,
      },
      {
        rapport_id: 2,
        titre: 'Rapport qualité air',
        date: Math.floor(Date.now() / 1000) - 86400,
        project_id: 119,
      },
      {
        rapport_id: 3,
        titre: 'Rapport température',
        date: Math.floor(Date.now() / 1000) - 172800,
        project_id: 119,
      },
      {
        rapport_id: 4,
        titre: 'Rapport humidité',
        date: Math.floor(Date.now() / 1000) - 259200,
        project_id: 119,
      },
      {
        rapport_id: 5,
        titre: 'Rapport sécurité',
        date: Math.floor(Date.now() / 1000) - 345600,
        project_id: 119,
      },
      {
        rapport_id: 6,
        titre: 'Rapport Galerie Intertube',
        date: Math.floor(Date.now() / 1000) - 432000,
        project_id: 1119,
      },
    ],
    dashboard: {
      dashboard_id: 201,
      dashboard_name: 'Tableau de bord CO05a',
      project_id: 119,
      image_url:
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23e8f4f8" width="400" height="300"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%234c4c4c" font-size="24" font-weight="bold"%3ETablau CO05a%3C/text%3E%3C/svg%3E',
    },
    graph: {
      graph_id: 301,
      graph_name: 'Graphe Température',
      project_id: 119,
    },
    views: [
      {
        view_id: 2330,
        view_name: 'Plan site de sécurité CO05a',
        view_title: 'Localisation des capteurs',
        project_id: 119,
        view_projection: 0,
        view_copyright: 'ITM+',
        view_flag_fix_pos: 1,
        view_type: 0,
        is_main_view: 1,
        is_visible: 1,
        is_clustered: 1,
        center: [48.8566, 2.3522],
        zoom: 12,
      },
      {
        view_id: 2358,
        view_name: 'Plan Galerie Intertube',
        view_title: 'Galerie Intertube',
        project_id: 1119,
        view_projection: 0,
        view_copyright: 'ITM+',
        view_flag_fix_pos: 1,
        view_type: 0,
        is_main_view: 1,
        is_visible: 1,
        is_clustered: 1,
        center: [48.9, 2.4],
        zoom: 13,
      },
    ],
    view: {
      view_id: 2330,
      view_name: 'Plan site de sécurité CO05a',
      view_title: 'Localisation des capteurs',
      project_id: 119,
      center: [48.8566, 2.3522],
      zoom: 12,
    },
    viewData: {
      view: {
        view_id: 2393,
        view_name: 'Convergences CT PM 17',
        view_title: 'Temperature Monitor',
        bounds_image: [
          [0, 0],
          [1080, 1920],
        ],
        created_at: '2024-06-15T10:30:00Z',
        updated_at: '2024-06-15T10:30:00Z',
      },
      layers_list: [
        {
          layer_id: 6340,
          layer_name: 'Base Map',
          layer_path:
            'http://127.0.0.1/argos_frontend/api_argos/api/VUE/views/view_2393/layers/view_pic6340.png',
          bounds_image: [
            [0, 0],
            [1080, 1920],
          ],
          opacity: 1.0,
        },
      ],
      data_objects_list_view: [
        {
          viewobj_id: 3939,
          viewobj_type: 2,
          viewobj_name: 'Temperature Series - FOP Sensors',
          viewobj_title: 'FOP Temperature Data',
          coord_x: 50,
          coord_y: 50,
          coord_z: 0,
          data: {
            config: {
              title: 'Température - CTX',
              subtitle: 'JOP 2024',
              xaxis: {
                title: 'Time',
                type: 'date',
              },
              yaxis: {
                title: 'Température [°C]',
              },
            },
            data: [
              {
                x: [
                  1719838941, 1719838981, 1719839021, 1719839061, 1719839101,
                  1719839141, 1719839181, 1719839221, 1719839261, 1719839301,
                ],
                y: [22.3, 22.5, 22.8, 22.9, 23.0, 23.2, 23.5, 23.7, 23.9, 24.0],
                type: 'scatter',
                mode: 'lines',
                name: 'FOP 1',
                sensor_name: 'FOP 1',
                color: '#000000',
              },
              {
                x: [
                  1719838941, 1719838981, 1719839021, 1719839061, 1719839101,
                  1719839141, 1719839181, 1719839221, 1719839261, 1719839301,
                ],
                y: [22.1, 22.4, 22.6, 22.7, 22.9, 23.1, 23.4, 23.6, 23.8, 23.9],
                type: 'scatter',
                mode: 'lines',
                name: 'FOP 2',
                sensor_name: 'FOP 2',
                color: '#FF6B6B',
              },
              {
                x: [
                  1719838941, 1719838981, 1719839021, 1719839061, 1719839101,
                  1719839141, 1719839181, 1719839221, 1719839261, 1719839301,
                ],
                y: [22.4, 22.6, 22.9, 23.1, 23.2, 23.4, 23.6, 23.8, 24.0, 24.1],
                type: 'scatter',
                mode: 'lines',
                name: 'FOP 3',
                sensor_name: 'FOP 3',
                color: '#4ECDC4',
              },
            ],
          },
        },
      ],
    },
    projects: [
      {
        project_id: 119,
        project_name: 'Projet CO05a',
        favorite: true,
      },
      {
        project_id: 1119,
        project_name: 'Projet Galerie Intertube',
        favorite: true,
      },
    ],
  },
};
